import { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";

import AdminModualForm from "./AdminModualForm";
import Swal from "sweetalert2";
import { useSiteContext } from "../../contexts/SiteProvider";
import { MODULES_URLS } from "../../api/AdminUrls";
import { get, post } from "../../services/smartApiService";
import { showAlertAutoClose } from "../../services/notifyService";
const AdminModule = () => {
  const [tabData, setTabData] = useState([]);
  const { openModal, closeModal } = useSiteContext();

  const loadTableData = () => {
    let URL = MODULES_URLS.GET_ALL;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);

  const deleteData = (id: any) => {
    const subscription = post(MODULES_URLS.DELETE, { id: id }).subscribe(
      (response) => {
        showAlertAutoClose("Deleted Successfully...", "success");
        closeModal();
        loadTableData();
        // setLoading(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Designation Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this User? This action cannot be reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Permission Update" : "Permission Form"}</>,
      content: <AdminModualForm loadTableData={loadTableData} data={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 40,
    };
    openModal(options);
  };
  const viewEditForm = (id: any) => {
    const subscription = post(MODULES_URLS.GET_ONE, {
      id: id,
    }).subscribe((response: any) => {
      openOfficesForm(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const buttons = [
    // {
    //   label: "",
    //   type: "icon",
    //   leftIcon: "fa fa-trash",
    //   classList: ["smart-hims-table-delete-icon"],
    //   onClick: (data: any) => {
    //     openDeleteModal(data["ID"]);
    //   },
    // },

    {
      label: "",
      type: "icon",
      leftIcon: " fa-pencil-square",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => {
        viewEditForm(data["ID"]);
      },
    },
  ];
  const StatusUpdate = (id: number, status: any) => {
    const subscription = post(MODULES_URLS.STATUS_UPDATE, { id, status }).subscribe(() => {
      loadTableData();
      subscription.unsubscribe(); // Proper cleanup
    });
  };
  
  const updateStatus = (itemIn: any) => {
    let new_status: number = itemIn.status === 5 ? 10 : 5;
    let isDisabling = new_status === 10;
  
    Swal.fire({
      html: isDisabling
        ? "<span style='color:red; font-weight:bold;'>Do you wish to DISABLE?</span>"
        : "Do you wish to <b>ENABLE</b>?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        updateStatusFinal(true, itemIn, new_status);
      }
    });
  };
  
  const updateStatusFinal = (selection: any, itemIn: any, new_status: number) => {
    if (selection) {
      itemIn.status = new_status;
      StatusUpdate(itemIn.ID, new_status);
    }
  };
  
  const SwitchForm = (item: any) => {
    return (
      item.ID && (
        <div className="field">
          <input
            id={`switchExample_${item.ID}`}
            type="checkbox"
            name={`switchExample_${item.ID}`}
            className="switch is-small is-rounded"
            checked={item.status === 5} 
            onChange={() => updateStatus(item)}
          />
          <label htmlFor={`switchExample_${item.ID}`}></label> 
        </div>
      )
    );
  };
  
  const RolesList = (data: any) => {
    return (
      <div className="tags is-small">
        {data?.sub_data?.map((user: any) => (
          <div className="tag is-success mx-1">{user.action}</div>
        ))}
      </div>
    );
  };
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },

    {
      title: "Module Name",
      index: "module_name",
      width: "30",
    },
    { title: "Status", index: "status", valueFunction: SwitchForm },
    {
      title: "Permissions",
      index: "roles",
      width: "30",
      valueFunction: RolesList,
    },
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-8",
      custom: <p className="is-size-4 has-text-weight-bold">Modules</p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
  ];

  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={tableTop}
          tableProps={{
            className: "is-hoverable is-bordered smart-efl-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          paginationProps={{
            pageSize: 30,
          }}
        />
      </div>
    </>
  );
};

export default AdminModule;
